export default __webpack_public_path__ + "static/media/birds.383d5504.mp3";